
const moment = require('moment-timezone');

const DATE_FORMAT = 'DD.MM.YYYY';
const TIME_ZONE = 'Europe/Moscow';
const momentRepr = s => moment.tz(s, DATE_FORMAT, true, TIME_ZONE);
const momentReprExtend = { repr: { moment: momentRepr } };

module.exports = {
	DATE_FORMAT,
	TIME_ZONE,
	momentRepr,
	momentReprExtend,
};
